import React from 'react';
import cx from 'classnames';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import API from 'shared/constants/api';
import { verifyYear } from 'shared/helpers/users';
import LoginUsForm from 'shared/components/LoginUsForm';
import { withTranslate } from 'shared/hocs/withTranslate';
import CURRENCIES from 'shared/constants/json/currencyObj.json';
import NOTIFICATION_TYPES from 'shared/actions/notificationTypes';
import { enqueueNotification } from 'shared/actions/notifications';
import Contacts from 'mobile/routes/personal/edit/components/Contacts/Contacts';
import ModalContainer from 'shared/components/ModalContainer/ModalContainer';
import NumberInput from 'shared/components/NumberInput/NumberInput';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { withFetch } from 'shared/hocs/withFetch';
import { getFormattedDateFns } from 'shared/helpers/locale';

import Link from '../Link';
import s from './CarDriveForm.css';

const SUCCESS_MESSAGE = 'Данные успешно отправлены. С вами свяжутся в ближайшее время';
const ERROR_MESSAGE = 'Не удалось отправить форму. Попробуйте позже.';
const WRONG_YEAR_MESSAGE = 'Введите год в промежутке от 1900 до';

class CarDriveForm extends React.PureComponent {
  static propTypes = {
    firmId: PropTypes.number.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    fetch: PropTypes.func.isRequired,
    countries: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    enqueueNotification: PropTypes.func.isRequired,
    makes: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    user: PropTypes.shape().isRequired,
    //
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isOpen: false,
  };

  state = {
    showVerifyPhones: false,
    showAuthForm: false,
    country: null,
    make: null,
    model: null,
    models: [],
    year: 0,
    price: 0,
    error: '',
  };

  handleMakeChange = make => {
    const { fetch } = this.props;

    if (!make) this.setState({ make: null, model: null, models: [] });
    else
      Promise.resolve(make && fetch(API.CMM.modelsByMake(make.id)))
        .then(r => r.json())
        .then(models => {
          this.setState({ make, model: null, models });
        });
  };

  handleYearChange = year => {
    const { error } = this.state;
    this.setState({ year: +year });

    if (error && !verifyYear(year)) this.setState({ error: '' });
  };

  sendForm = requestParams => {
    const {
      user: { token },
      fetch,
      t,
    } = this.props;

    Promise.resolve(
      fetch(API.CAR_DRIVE.SEND_FORM, {
        method: 'POST',
        headers: {
          Authorization: `JWT ${token}`,
        },
        body: JSON.stringify(requestParams),
      }),
    ).then(response => {
      if (response.ok) {
        this.props.enqueueNotification({
          text: t(SUCCESS_MESSAGE),
          type: NOTIFICATION_TYPES.SUCCESS,
        });
      } else {
        this.props.enqueueNotification({
          text: t(ERROR_MESSAGE),
          type: NOTIFICATION_TYPES.ERROR,
        });
      }
    });
  };

  verifyPhone = user =>
    user && user.phones && user.phones.find(({ is_verified: isVerified }) => !!isVerified);

  handleSubmit = () => {
    const { make, model, country, year, price } = this.state;
    const { user: userInfo, firmId, onClose, t } = this.props;
    const { token, user } = userInfo;

    const isPhoneVerified = this.verifyPhone(user);

    if (verifyYear(year))
      this.setState({
        error: `${t(WRONG_YEAR_MESSAGE)} ${Number(getFormattedDateFns(new Date(), 'yyyy'))} ${t(
          'года',
        )}`,
      });
    else if (!token) this.setState({ showAuthForm: true });
    else if (!isPhoneVerified) this.setState({ showVerifyPhones: true });
    else {
      const requestParams = {
        agency: firmId,
        year,
        price,
        country: country && country.id,
        make: make && make.id,
        model: model && model.id,
      };
      Object.keys(requestParams).filter(key => !requestParams[key] && delete requestParams[key]);

      this.sendForm(requestParams);
      onClose();
    }
  };

  render() {
    const { onClose, isOpen, countries, makes, user, t } = this.props;
    const {
      make,
      model,
      models,
      price,
      year,
      country,
      showAuthForm,
      error,
      showVerifyPhones,
    } = this.state;

    const showVerifyPhonesSection = !this.verifyPhone(user.user) && showVerifyPhones;

    return (
      <ModalContainer modalCN={s.modal} onClose={onClose} isOpen={isOpen}>
        {showAuthForm && !user.token ? (
          <div className={s.loginSection}>
            <LoginUsForm notRedirect />
          </div>
        ) : (
          <div className={s.root}>
            <div className={s.title}>{t('Заявка на пригон авто')}</div>
            <div className={s.selectContainer}>
              <Select
                value={make}
                labelKey="title"
                valueKey="id"
                placeholder={'Марка'}
                options={makes}
                onChange={this.handleMakeChange}
                disabled={makes && !makes.length}
              />
            </div>
            <div className={s.selectContainer}>
              <Select
                value={model}
                labelKey="title"
                valueKey="id"
                placeholder={t('Модель')}
                options={models}
                onChange={data => this.setState({ model: data })}
                disabled={models && !models.length}
              />
            </div>
            <div className={cx(s.doubleContainer, s.priceSection)}>
              <NumberInput
                className={cx(s.input, s.firstInput)}
                placeholder={t('Год')}
                onChange={this.handleYearChange}
                value={year}
                separateThousands={false}
              />
              <NumberInput
                className={s.input}
                placeholder={t('Цена')}
                onChange={data => this.setState({ price: +data })}
                value={price}
                separateThousands
              />
              <span className={s.currencyText}>{CURRENCIES.eur.title}</span>
            </div>
            <div className={s.selectContainer}>
              <Select
                value={country}
                labelKey="title"
                valueKey="id"
                placeholder={t('Страна')}
                options={countries}
                onChange={data => this.setState({ country: data })}
                disabled={countries && !countries.length}
              />
            </div>
            {error && <span className={s.error}>{error}</span>}
            <Link
              onClick={this.handleSubmit}
              className={s.submitLink}
              disabled={showVerifyPhonesSection}
            >
              {t('Отправить заявку')}
            </Link>
            {showVerifyPhonesSection && (
              <div className={s.verifyPhones}>
                <Contacts isSubmittingData={false} onSubmitEmail={() => {}} isCarEdit />
                <span className={cx(s.error, s.phoneError)}>
                  {t('Укажите или подтвердите телефон')}
                </span>
              </div>
            )}
          </div>
        )}
        <span className={s.closeBtn} onClick={onClose} />
      </ModalContainer>
    );
  }
}

const mapDispatchToProps = { enqueueNotification };

const mapStateToProps = ({ searchForm, user }) => ({
  makes: searchForm && searchForm.vocabulary.makes,
  user,
});

export default withStyles(s)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslate(withFetch(CarDriveForm))),
);



// WEBPACK FOOTER //
// ./src/shared/components/CarDriveForm/CarDriveForm.js